import { QueueManagementConstants } from './../QueueManagementConstants';
export class QueuesService {
    static $inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN', '$translate', 'BlipToastService'];
    constructor(MessagingHubService, MESSAGINGHUBDOMAIN, $translate, BlipToastService) {
        'ngInject';
        this.MessagingHubService = MessagingHubService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.$translate = $translate;
        this.BlipToastService = BlipToastService;
    }
    /**
     * Add or update and queue to an application
     * @param queue
     */
    async save(queue) {
        return await this.MessagingHubService.sendCommand({
            method: 'set',
            to: `${QueueManagementConstants.DESTINATION.DESK}${this.MESSAGINGHUBDOMAIN}`,
            type: 'application/vnd.iris.desk.attendancequeue+json',
            uri: QueueManagementConstants.URL.ATTENDANCE_QUEUES,
            resource: queue,
        });
    }
    /**
     * Delete an application queue
     * @param queue
     */
    async delete(queue) {
        return await this.MessagingHubService.sendCommand({
            method: 'delete',
            to: `${QueueManagementConstants.DESTINATION.DESK}${this.MESSAGINGHUBDOMAIN}`,
            uri: `${QueueManagementConstants.URL.ATTENDANCE_QUEUES}/${encodeURIComponent(queue.id)}`,
        });
    }
    /**
     * Get queues for this bot
     */
    async getQueues(skip = 0, take = 100) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `${QueueManagementConstants.DESTINATION.DESK}${this.MESSAGINGHUBDOMAIN}`,
            uri: `${QueueManagementConstants.URL.ATTENDANCE_QUEUES}?$skip=${skip}&$take=${take}`,
        });
    }
    /**
     * Get attendants for queue*
     *  @param queueId
     */
    async getAttendants(queueId) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `${QueueManagementConstants.DESTINATION.DESK}${this.MESSAGINGHUBDOMAIN}`,
            uri: `${QueueManagementConstants.URL.ATTENDANCE_QUEUES}${encodeURIComponent(queueId)}`,
        });
    }
    /**
     * Get queue for id
     * @param application
     * @param queueId
     */
    getQueue(queueId) {
        return this.MessagingHubService.sendCommand({
            method: 'get',
            to: `${QueueManagementConstants.DESTINATION.DESK}${this.MESSAGINGHUBDOMAIN}`,
            uri: `${QueueManagementConstants.URL.ATTENDANCE_QUEUES}/${encodeURIComponent(queueId)}`,
        });
    }
    /**
     * Get queues according to the filter
     * @param filter
     * @param skip
     * @param take
     */
    async filterQueues(filter = '', skip = 0, take = 100) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `${QueueManagementConstants.DESTINATION.DESK}${this.MESSAGINGHUBDOMAIN}`,
            uri: `${QueueManagementConstants.URL.ATTENDANCE_QUEUES}?$filter=(substringof('${encodeURIComponent(filter)}'%2CName))&$skip=${skip}&$take=${take}`,
        });
    }
    async fetchQueues() {
        try {
            let queues;
            const { items } = await this.getQueues();
            queues = items.map(item => {
                let queue;
                queue = {
                    name: item.name,
                    ownerIdentity: item.ownerIdentity,
                    isActive: item.isActive,
                };
                return queue;
            });
            return queues;
        }
        catch (e) {
            console.error(e);
        }
    }
    async fetchAttendants() {
        try {
            let attendants;
            const { items } = await this.getQueues();
            attendants = items.map(item => {
                let attendant;
                attendant = {
                    identity: item.identity,
                    email: item.email,
                    fullName: item.fullName,
                    isEnabled: item.isEnabled ?? true,
                };
                return attendant;
            });
            return attendants;
        }
        catch (e) {
            console.error(e);
        }
    }
    async showToast(messageReference, type) {
        const msg = await this.$translate(messageReference);
        const toastOptions = { msg, buttonText: await this.$translate('queue-management.queues.ok') };
        await this.BlipToastService.show(type, toastOptions);
    }
}
QueuesService.$inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN', '$translate', 'BlipToastService'];
